<template>
  <form class="form" @submit.prevent="createUser">
    <h2>{{ $t('newExaminer.TITLE') }}</h2>
    <BaseInput
      :label="$t('newExaminer.label.FIRST_NAME')"
      v-model="examiner.first_name"
      type="text"
      :placeholder="$t('newExaminer.FIRST_NAME_PLACEHOLDER')"
      autocomplete="off"/>
    <BaseInput
      :label="$t('newExaminer.label.LAST_NAME')"
      v-model="examiner.last_name"
      type="text"
      :placeholder="$t('newExaminer.LAST_NAME_PLACEHOLDER')"
      autocomplete="off"/>
    <BaseInput
      :label="$t('newExaminer.label.EMAIL')"
      :errors="errors.email"
      v-model="examiner.email"
      type="text"
      :placeholder="$t('newExaminer.EMAIL_PLACEHOLDER')"
      autocomplete="username"/>
    <BaseInput
      :label="$t('newExaminer.label.PASSWORD')"
      :errors="errors.password"
      :help="$t('newExaminer.PASSWORD_HELP')"
      v-model="examiner.password"
      type="password"
      :placeholder="$t('newExaminer.PASSWORD_PLACEHOLDER')"
      autocomplete="new-password"/>
    <BaseInput
      :label="$t('newExaminer.label.PASSWORD2')"
      :errors="errors.password2"
      :help="$t('newExaminer.PASSWORD_HELP')"
      v-model="examiner.password2"
      type="password"
      :placeholder="$t('newExaminer.PASSWORD2_PLACEHOLDER')"
      autocomplete="new-password"/>
    <div v-if="errors.form.length" class="errors-container">
      <ul>
        <li class="error" v-for="error in errors.form" :key="error">{{ error }}</li>
      </ul>
    </div>
    <div class="submit-container">
      <input class="primary-button" type="submit" :value="$t('newExaminer.SUBMIT_BUTTON')">
    </div>
  </form>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { unpackDetails } from '@/utils/utils.format'

export default {
  name: 'NewUser',
  data () {
    return {
      examiner: this.newExaminer(),
      errors: this.newErrors()
    }
  },
  methods: {
    newExaminer () {
      return {
        email: '',
        password: '',
        password2: '',
        first_name: '',
        last_name: '',
        company: null
      }
    },
    newErrors () {
      return {
        form: [],
        email: [],
        password: [],
        password2: []
      }
    },
    checkForm () {
      this.errors = this.newErrors()
      const { examiner } = this

      if (!this.user.companies.length) {
        this.errors.form.push(this.$t('newExaminer.error.COMPANY_REQUIRED'))
      }

      if (!(examiner.email && examiner.password && examiner.password2)) {
        this.errors.form.push(this.$t('newExaminer.error.FIELD_REQUIRED'))
      }

      if (examiner.password !== examiner.password2) {
        this.errors.form.push(this.$t('newExaminer.error.PASSWORD_MISMATCH'))
      }

      return !this.errors.form.length
    },
    createUser () {
      const formValid = this.checkForm()

      if (formValid) {
        this.examiner.company = this.user.companies[0]

        const newExaminerPromise = this.createNewExaminer(this.examiner)

        this.$awn.async(
          newExaminerPromise,
          this.onExaminerSuccess,
          this.onExaminerFailure,
          this.$t('newExaminer.awn.SEND_FORM')
        )
      }
    },
    onExaminerSuccess () {
      this.$awn.success(this.$t('newExaminer.awn.CREATE_SUCCESS'))
      this.$router.push({ name: 'Exams' })
    },
    onExaminerFailure (error) {
      const details = error.response?.data || {}

      unpackDetails(this.errors, details)

      this.$awn.alert(this.$t('newExaminer.awn.CREATE_ERROR'))
    },
    ...mapActions(['createNewExaminer'])
  },
  computed: mapState(['user'])
}
</script>

<style lang="scss" scoped>
@import "~@/styles/base";

</style>
